const actions = {
  checkServicesStatus: (context, servicesData) => context.commit('SAVE_STATUS', servicesData)
};

export default {
  actions
};
